
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/discord",
      function () {
        return require("private-next-pages/integrations/discord.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/discord"])
      });
    }
  